import { twMerge } from "tailwind-merge";
import logoSvg from "@shared/assets/logos/pollinator.svg";
import altLogoSvg from "@shared/assets/logos/pollinator_alt.svg";

type PollinatorLogoProps = {
  className?: string;
  size?: "sm" | "md" | "lg";
  theme?: "light" | "dark";
};

export function PollinatorLogo({
  className,
  size = "sm",
  theme = "dark",
}: PollinatorLogoProps) {
  return (
    <div
      className={twMerge(
        "w-40",
        size === "sm" && "w-24",
        size === "md" && "w-36",
        size === "lg" && "w-64",
        "text-brand-800",
        className
      )}
    >
      <img
        src={theme === "light" ? altLogoSvg : logoSvg}
        alt="Pollinator logo"
        className="w-full object-contain"
      />
    </div>
  );
}

export default PollinatorLogo;
